import { render } from "./WhyNotToUse.vue?vue&type=template&id=9a3e7750&scoped=true"
const script = {}

import "./WhyNotToUse.vue?vue&type=style&index=0&id=9a3e7750&scoped=true&lang=scss"

import exportComponent from "/home/node/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a3e7750"]])

export default __exports__